import React, { useEffect, useState } from "react";
import {
  Grid, Typography, Paper, IconButton, Button,
  Modal, Box, TextField
} from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import useAuth from './useAuth.js';
import { useNotification } from "../../components/NotificationContext";

const CouponEdit = () => {
  useAuth();
  const showNotification = useNotification();
  const navigate = useNavigate();

  const [coupons, setCoupons] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedCoupon, setSelectedCoupon] = useState(null);

  const handleBackClick = () => navigate(-1);
  const token = localStorage.getItem("token");

  const fetchCoupons = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/product/coupon`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      setCoupons(data);
    } catch (error) {
      console.error("Kuponlar alınamadı:", error);
    }
  };

  const handleBoxClick = (coupon) => {
    setSelectedCoupon(coupon);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedCoupon(null);
  };

  const handleUpdate = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/product/coupon/${selectedCoupon.id}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(selectedCoupon),
      });
      const result = await res.json();
      showNotification(result.message, "success");
      fetchCoupons();
      handleClose();
    } catch (error) {
      showNotification("Güncelleme başarısız", "error");
    }
  };

  const handleDelete = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/product/coupon/${selectedCoupon.id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`
        },
      });
      const result = await res.json();
      showNotification(result.message, "success");
      fetchCoupons();
      handleClose();
    } catch (error) {
      showNotification("Silme başarısız", "error");
    }
  };

  useEffect(() => {
    fetchCoupons();
  }, []);

  return (
    <Grid container justifyContent="center" alignItems="center">
      <Grid size={{ xs: 12, sm: 10,md:10 }}>
        <Paper elevation={5} style={{ padding: '30px', borderRadius: '15px' }}>
          <IconButton onClick={handleBackClick} style={{ marginBottom: '10px' }}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h4" align="center" gutterBottom>
            Kupon Düzenle
          </Typography>

          <Grid container spacing={2}>
            {coupons.map((coupon) => (
              <Grid size={{ xs: 12, sm: 6,md:4 }} key={coupon.id}>
                <Paper
                  onClick={() => handleBoxClick(coupon)}
                  style={{ padding: '15px', cursor: 'pointer', borderRadius: '10px', backgroundColor: '#f5f5f5' }}
                >
                  <Typography variant="h6">{coupon.name}</Typography>
                  <Typography>Limit: {coupon.usage_limit}</Typography>
                  <Typography>İndirim: %{coupon.discount_percent}</Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Paper>
      </Grid>

      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: 'absolute', top: '50%', left: '50%',
            transform: 'translate(-50%, -50%)', width: 400, bgcolor: 'background.paper',
            borderRadius: 2, boxShadow: 24, p: 4,
          }}
        >
          <Typography variant="h6" gutterBottom>Kupon Düzenle</Typography>
          <TextField
            label="İsim"
            fullWidth
            margin="normal"
            value={selectedCoupon?.name || ""}
            onChange={(e) => setSelectedCoupon({ ...selectedCoupon, name: e.target.value })}
          />
          <TextField
            label="Kullanım Hakkı"
            fullWidth
            margin="normal"
            value={selectedCoupon?.usage_limit || ""}
            onChange={(e) => setSelectedCoupon({ ...selectedCoupon, usage_limit: e.target.value })}
          />
          <TextField
            label="İndirim (%)"
            fullWidth
            margin="normal"
            value={selectedCoupon?.discount_percent || ""}
            onChange={(e) => setSelectedCoupon({ ...selectedCoupon, discount_percent: e.target.value })}
          />

          <Grid container spacing={2} justifyContent="flex-end" sx={{ mt: 2 }}>
            <Grid item>
              <Button variant="contained" color="error" onClick={handleDelete}>
                Sil
              </Button>
            </Grid>
            <Grid item>
              <Button variant="contained" onClick={handleUpdate}>
                Güncelle
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </Grid>
  );
};

export default CouponEdit;
